import React from 'react';
import Icons from '../Icons';
import { getRiskLabel, getRiskVariant } from './safeguardingUtils';

export default function SafeguardingSummary({ summary }) {
  if (!summary) return null;
  const riskLabel = getRiskLabel(summary.overallRisk);
  const riskVariant = getRiskVariant(summary.overallRisk);
  const LeadIcon = Icons.Users;
  const AlertIcon = Icons.Alert;
  const ClockIcon = Icons.Clock;

  return (
    <section className="sp-summary-strip" aria-label="Safeguarding summary">
      <div className="flex flex-wrap items-center gap-4">
        <div className="sp-summary-item">
          <div className="sp-summary-label">Overall risk</div>
          <div className={`sp-summary-risk sp-summary-risk--${riskVariant}`}>
            <span aria-hidden="true">
              <AlertIcon />
            </span>
            {riskLabel}
          </div>
        </div>
        <div className="sp-summary-item">
          <div className="sp-summary-label">Active items</div>
          <div className="sp-summary-value">{summary.activeCount}</div>
        </div>
        <div className="sp-summary-item">
          <div className="sp-summary-label">Overdue reviews</div>
          <div className={`sp-summary-value ${summary.overdueCount > 0 ? 'sp-summary-value--warning' : ''}`}>
            {summary.overdueCount}
          </div>
        </div>
        <div className="sp-summary-item">
          <div className="sp-summary-label">Safeguarding lead</div>
          <div className="sp-summary-lead">
            <span aria-hidden="true">
              <LeadIcon />
            </span>
            {summary.leadAssigned ? (
              <span>{summary.leadName}</span>
            ) : (
              <span className="sp-summary-warning">Unassigned</span>
            )}
          </div>
        </div>
        <div className="sp-summary-item">
          <div className="sp-summary-label">Next review</div>
          <div className="sp-summary-lead">
            <span aria-hidden="true">
              <ClockIcon />
            </span>
            <span>{summary.overdueCount > 0 ? 'Overdue items' : 'On track'}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
